"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelpers = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
const Constants_1 = require("../Constants");
const React = __importStar(require("react"));
class CommonHelpers {
    static toQueryString(params) {
        const queryParams = new URLSearchParams();
        Object.entries(params)
            .filter(([, value]) => value !== null)
            .forEach(([key, value]) => queryParams.append(key, String(value)));
        return queryParams.toString();
    }
    static booleanToText(value, trueValue, falseValue) {
        const valueToConvert = typeof value === 'string' ? JSON.parse(value) : value;
        return valueToConvert ? trueValue : falseValue;
    }
    static getPrintableDocuments(allDocuments, nonPrintableDocuments) {
        return allDocuments.filter(doc => !nonPrintableDocuments.some(nonPrintDoc => doc.name.includes(nonPrintDoc)));
    }
    static setSessionStorage(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    static getSessionStorage(key) {
        const object = window.sessionStorage.getItem(key);
        if (object) {
            return JSON.parse(object);
        }
        else {
            return null;
        }
    }
    static deleteSessionStorage(key) {
        window.sessionStorage.removeItem(key);
    }
    static getRemovedAndAddedDrivers(currentDrivers) {
        const added = [];
        const removed = [];
        const initialDriversList = CommonHelpers.getSessionStorage("initialAdditionalDrivers");
        if (currentDrivers && initialDriversList) {
            const initialDriverSet = new Set(initialDriversList.map((driver) => driver.personId));
            const currentDriverSet = new Set(currentDrivers.map((driver) => driver.personId));
            currentDrivers.forEach((driver, index) => {
                if (!initialDriverSet.has(driver.personId)) {
                    added.push((0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, index < currentDrivers.length - 1 ? ', ' : ''] }));
                }
            });
            initialDriversList.forEach((driver, index) => {
                if (!currentDriverSet.has(driver.personId)) {
                    removed.push((0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, index < initialDriversList.length - 1 ? ', ' : ''] }));
                }
            });
        }
        return { addedDrivers: added, removedDrivers: removed };
    }
    static setEmailInLvDataLayer(email) {
        const encoder = new TextEncoder();
        if (email) {
            const data = encoder.encode(email);
            crypto.subtle.digest('SHA-256', data).then((hashBuffer) => {
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                window.LvDataLayer.hashedEmailAddress = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            });
        }
    }
    /*
       E.164 is the international standard format for phone numbers.
       For a UK mobile number, the format is: +44 followed by the number without the leading 0.

       Example:
           - UK local format: 07123 456789
           - E.164 format: +447123456789

       Rules:
           - Start with +
           - Include country code (44 for the UK)
           - Remove spaces, dashes, and the leading 0 from the local number.
       */
    static normalizeMobileNumberToE164(mobileNumber) {
        const trimmedMobileNumber = mobileNumber ? mobileNumber.trim() : "";
        if (!trimmedMobileNumber) {
            return "";
        }
        const startsWithPlus = trimmedMobileNumber.startsWith("+");
        const digitsOnly = trimmedMobileNumber.replace(/\D/g, "");
        if (!digitsOnly) {
            return "";
        }
        if (startsWithPlus) {
            return `+${digitsOnly}`;
        }
        if (digitsOnly.startsWith("00")) {
            return `+${digitsOnly.substring(2)}`;
        }
        if (digitsOnly.startsWith("44")) {
            return `+${digitsOnly}`;
        }
        if (digitsOnly.startsWith("0")) {
            return `+44${digitsOnly.substring(1)}`;
        }
        return `+${digitsOnly}`;
    }
    static getAmountWithDecimalDigits(amount) {
        const fixedAmount = 1 * amount;
        return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(fixedAmount);
    }
    static getAmountToDisplay(amount) {
        if ((amount % 1) === 0) {
            return "£" + new Intl.NumberFormat('en-UK').format(amount);
        }
        else {
            return this.getAmountWithDecimalDigits(amount);
        }
    }
    static getPolicyHolderFullName(interaction) {
        return interaction.policyHolder.firstName + " " + interaction.policyHolder.lastName;
    }
    static getDate(environmentVariable) {
        const date = (0, moment_1.default)(environmentVariable);
        if (!date.isValid()) {
            throw new Error("Invalid date format. Expected YYYY-MM-DD: " + environmentVariable);
        }
        return date.toDate();
    }
    static showOverdueInstalmentBanner(showMissedPaymentBanner, interaction, isDirectDebit, showOverdueInstalmentsBanner, annualPolicyInfo) {
        if ((showMissedPaymentBanner && isDirectDebit && interaction.process !== Constants_1.INTERACTION_PROCESS_MTC_LV) ||
            (!isDirectDebit && showMissedPaymentBanner && Object.keys(annualPolicyInfo.unpaidInstallmentIdToAmount).length === 2)) {
            showOverdueInstalmentsBanner = showMissedPaymentBanner;
        }
        return showOverdueInstalmentsBanner;
    }
    static renderBracketedList(items) {
        if (items.length === 1) {
            return (0, jsx_runtime_1.jsxs)("strong", { children: ["[", items[0], "]"] });
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: items.map((item, index) => {
                const isLast = index === items.length - 1;
                const isSecondToLast = index === items.length - 2;
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: ["[", item, "]"] }), !isLast && (isSecondToLast ? ' and ' : ', ')] }, item));
            }) }));
    }
}
exports.CommonHelpers = CommonHelpers;
//# sourceMappingURL=CommonHelpers.js.map